export default {
  Parametrizacoes: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "parametrizacoes"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Parametrizacoes.js
// module id = etIN
// module chunks = 13